export default "/images/36f49fdb63d1767842aa12e1fcf46082.avif";